import React from "react";
import { Button } from "@mui/material";
import "../CSS/HomePackages.css"; // Import external CSS file

const HomePackages = ({ name, price, features, isPromo, promoPrice, promoEndDate }) => {

    const boldFeatures = {
        Standard: ["Effects", "RSVP", "Photo Gallery"],
        Premium: ["QR Bank", "Gift Wishlist", "Weather Forecast", "Digital Photobooth"]
    };

    const formattedPromoDate = promoEndDate
        ? new Date(promoEndDate).toLocaleDateString("en-MY", {
            day: "numeric",
            month: "short",
            year: "numeric",
        })
        : "";

    return (
        <div className={`package-base-card ${isPromo ? "promo-card" : ""}`}>

            {isPromo && (
                <div className="promo-badge">
                    PROMO
                </div>
            )}

            <div className="price-details">
                <span className="package-name">{name}</span>

                {isPromo ? (
                    <>
                        <span className="package-old-price">
                            RM{price}
                        </span>

                        <span className="package-promo-price">
                            RM{promoPrice}
                        </span>

                        <span className="package-promo-end">
                            Promo until {formattedPromoDate}
                        </span>
                    </>
                ) : (
                    <span className="package-price">
                        RM{price}
                    </span>
                )}
            </div>
            <hr className="divider" />
            <div className="packages-details">
                {features.map((feature, index) => {
                    const isBold = boldFeatures[name]?.includes(feature);
                    return (
                        <div
                            key={index}
                            className="package-feature"
                            style={{ fontWeight: isBold ? "bold" : "normal" }}
                        >
                            {isBold ? `+ ${feature}` : feature}
                        </div>
                    );
                })}

            </div>
            <Button
                variant="contained"
                disableElevation
                onClick={() => window.open(`/design-preview/floral-026?samplePackage=${name}&QR=true&gift=true`, '_blank')}
                sx={{
                    textTransform: "none",
                    width: "100%",
                    backgroundColor: "#68D2D2",
                    borderRadius: "25px",
                    paddingX: 3,
                    paddingY: 1,
                    marginTop: "10px",
                }}
            >
                View Sample
            </Button>
        </div>
    );
};

export default HomePackages;
